import React from "react";

import classnames from "classnames";

import { Surface } from "Cobalt/Surface";
import Icon from "Common/Icon";
import type { IconProps } from "Common/Icon";
import BodyText from "Theme/BodyText";

import makeBem from "Utils/makeBem";

export const bem = makeBem("EmptyState");
export type EmptyStateProps = IconProps & {
  children: React.ReactNode;
  title?: string;
  titleProps?: any;
  className?: string;
};
export const EmptyState = ({ icon = "plus", size = "3x", flavor = "solid", title, titleProps, children, className, ...rest }: EmptyStateProps) => (
  <Surface p={3} pt={0} className={classnames(bem(), className)} {...rest}>
    <>
      <Icon icon={icon} size={size} flavor={flavor} className={bem("Icon")} />
      {title ? (
        <BodyText weight="bold" {...titleProps}>
          {title}
        </BodyText>
      ) : null}
      {children}
    </>
  </Surface>
);
